export default __webpack_public_path__ + "static/media/regeneraFacebook-1200x630.97ff8434.jpg";